export default __webpack_public_path__ + "static/no-result-found-56fac16e104a3d1c7b6ddc2447a50ee8.svg";